

<template lang="pug">
    .settings-table-paging
        .paging-item.paging-item--btn(@click="setPage(page - 1)")
            svg-icon(iconId="arrow-left-sm")
        template(v-for="item in items")
            .paging-item(v-if="item" @click="setPage(item)" :class="{ active: page == item }") {{ item }}
            .paging-item.paging-item--empty(v-else) ...
        .paging-item.paging-item--btn(@click="setPage(page + 1)")
            svg-icon(iconId="arrow-right-sm")
</template>

<script>
export default {
    name: 'settings-table-paging',

    props: {
        page: {
            required: true,
        },
        pages: {
            required: true,
        },
    },

    computed: {
        items() {
            const loPage = this.page - 1
            const hiPage = this.page + 1

            const items = []

            if (loPage >= 1) {
                items.push(1)
            }

            if (loPage >= 3) {
                items.push(0)
                items.push(loPage)
            } else {
                for (let i = 2; i < this.page; i++) {
                    items.push(i)
                }
            }

            items.push(this.page)

            if (hiPage <= this.pages - 2) {
                items.push(hiPage)
                items.push(0)
            } else {
                for (let i = hiPage; i < this.pages; i++) {
                    items.push(i)
                }
            }

            if (hiPage <= this.pages) {
                items.push(this.pages)
            }


            return items
        },
    },

    methods: {
        setPage(page) {
            if (1 <= page && page <= this.pages) {
                this.$emit('click', { page })
            }
        },
    }
}
</script>
